import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import * as styles from './Arrow.css';
import { getLeftArrow, getRightArrow } from './ArrowIcon';
import { EArrowsSize } from '../../../../types';
import { mergeStyles } from '@cian/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var Arrow = function Arrow(props) {
  var width = props.width,
    direction = props.direction,
    show = props.show,
    size = props.size,
    clickHandler = props.clickHandler;
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles(styles['click-area'], !show && styles['click-area-hidden'], direction < 0 && styles['click-area-left'], size === EArrowsSize.LARGE && styles['click-area-large'])), {}, {
    style: {
      width: width
    },
    onClick: function onClick() {
      return clickHandler && clickHandler(direction);
    },
    "data-testid": "Arrow",
    children: /*#__PURE__*/_jsx("div", {
      className: styles['background'],
      children: /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles(styles['icon-container'], direction > 0 && styles['icon-container-right'])), {}, {
        children: /*#__PURE__*/_jsx("div", {
          className: styles['icon'],
          children: direction < 0 ? getLeftArrow(size) : getRightArrow(size)
        })
      }))
    })
  }));
};